import { DataService } from './../../../services/data.service';
import { AuthService } from './../../../services/auth.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserType } from 'src/app/interfaces/user';
import { ToastrService } from 'ngx-toastr';

@Component({
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  form: FormGroup;
  isLoading: boolean;
  message: string;

  UserType = UserType;

  secondScreen = false;
  secondScreenType: UserType;
  secondScreenUID: string;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private data: DataService
    ) { }

  ngOnInit() {
    const {queryParams: params} = this.route.snapshot;

    this.form = this.fb.group({
      email: new FormControl(params && params.email ? params.email : '', [Validators.required]),
      name: new FormControl(params && params.name ? params.name : '', [Validators.required]),
      phone: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required]),
      type: new FormControl(params && params.type === 'student' ? UserType.Student : '', [Validators.required])
    })
  }

  async submit(){
    this.isLoading = true;
    try{
      if(this.form.invalid){
        throw Error('Form is invalid.');
      }

      const user = {
        username: this.form.value.email,
        name: this.form.value.name,
        password: this.form.value.password,
        phone: this.form.value.phone,
        type: this.form.value.type
      }

      this.authService.signup(user).subscribe(({data}) => {
        this.secondScreen = true;
        this.secondScreenType = +this.form.value.type as UserType;
        this.secondScreenUID = data._id;
      });

    }catch(e){
      console.error(e);

      this.message = e.message;
    }finally{
      this.isLoading = false;
    }
  }

  async afterUpdate(){
    try{
      this.authService.login({
        username: this.form.value.email,
        password: this.form.value.password
      }).subscribe((res) => {
        if(res && res.data){
          this.router.navigate(['/']);
        }
      })
    }catch(e){
      console.error(e);

      this.toastr.error(e.message);
    }
  }
}
